import { TUnit } from "@/interfaces";

// TODO merge with EAccessLevel
export enum AccessLevel {
  Basic,
  BasicPlus,
  Admin,
}

export interface IModule {
  id: number;
  name: string;
}

export interface IDashboard {
  id: number;
  name: string;
}

export interface IVessel {
  id: string;
  name: string;
  alphaId: string;
  modules: IModule[];
}

export interface IAltVessel {
  alphaId: string;
  vesselId: string;
  vesselName: string;
}

export interface IUserDetails {
  firstName: string;
  lastName: string;
  email: string;
  company: string;
  position: string;
  type: AccessLevel;
}

export interface IUserAssets {
  vessels: IVessel[];
  modules: IModule[];
  dashboards: IDashboard[];
}

export interface IUserSettings {
  darkTheme: boolean;
  units: TUnit;
  homepageModuleId: number;
  emailNotifications: boolean;
  mobileNotifications: boolean;
}

export interface IUserProfile {
  details: IUserDetails;
  assets: IUserAssets;
  settings: IUserSettings;
}
